import '../register-hero-video';
export * from '@fhs/routing/src/routes/_layout';
export { default } from '@fhs/routing/src/routes/_layout';
